import styles from "./gallery.module.css"
import Card from "../card/card"
import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useActiveFilters } from "../../services/context/ActiveFiltersContext"
import { setFiltredCards, setMoreCards, setClearCards} from "../../services/reducers/cards-filtred-for-gallery-slice"
import { setIsLoading } from "../../services/reducers/preloader-slice"

import Preloader from "../preloader/preloader"
function Gallery(
  {
    // filteredCards,
    // showMoreCardsBtn,
    // extentionCards
  }
) {
  const dispatch = useDispatch()
  const filters = useActiveFilters()
  const countryPoints = useSelector((store) => store.cardsFiltred.countryPoints)
  const companyPoints = useSelector((store) => store.cardsFiltred.companyPoints)

  const sectorPoints = useSelector((store) => store.cardsFiltred.sectorPoints)
  const categoryPoints = useSelector((store) => store.cardsFiltred.categoryPoints)
  const analysisPoints = useSelector((store) => store.cardsFiltred.analysisPoints)
  const subscriptionPoints = useSelector((store) => store.cardsFiltred.subscriptionPoints)
  const bondsPoints = useSelector((store) => store.cardsFiltred.bondsPoints)
  const isLoading = useSelector((store) => store.preloader.isLoading)
  const orderingPoints = useSelector(
    (store) => store.cardsFiltred.orderingPoints
  )
  // -------------------------    forGAllery
  const filteredCards = useSelector(
    (store) => store.cardsFiltredForGallery.filtredCards
  )
  // const cardsOnPageCount = useSelector((store) => store.cardsFiltredForGallery.cardsOnPageCount)
  const extentionCards = useSelector(
    (store) => store.cardsFiltredForGallery.extentionCards
  )
  
  // const [stateFilteredCards, setStateFilteredCards ] = useState([])
//     const filteredCardsMemo = useRef([])
// useEffect(() => {
//   filteredCardsMemo.current = filteredCards
// }, [filters.filterToggle])
useEffect(() => {
  filters.setNextPage(
    orderingPoints,
    categoryPoints,
    countryPoints,
    sectorPoints,
    companyPoints,
    analysisPoints,
    subscriptionPoints,
    bondsPoints)
    .then((res) => {
      // console.log(res);
      return res
    })
    .then((data) => {
      // console.log(data.results);
      
      dispatch(setFiltredCards(data.results))
      dispatch(setMoreCards(data.results))

    })
    
  }, [filters.pageCount])
// console.log(extentionCards);

  useEffect(() => {
    dispatch(setIsLoading(true))
    dispatch(setClearCards())
    filters.setAllGalleryCards(
      orderingPoints,
      categoryPoints,
      countryPoints,
      sectorPoints,
      companyPoints,
      analysisPoints,
      subscriptionPoints,
      bondsPoints
    )

  }, [
    // filters.pageCount,
    orderingPoints,
    categoryPoints,
    countryPoints,
    sectorPoints,
    companyPoints,
    analysisPoints,
    subscriptionPoints,
    bondsPoints
  ])
  // console.log(extentionCards);
  return (
    <section className={styles.sectionDisable}>
      {isLoading ? (
        <div className={styles.preloader}>
        <Preloader />
        </div>
      ) : (
        <div>
        <div className={styles.gallery}>
          {extentionCards.map((element, _, oneEl) => (

            <Card item={element} oneEl={oneEl} key={element.id} />
          ))}
        </div>
        {filteredCards.length >= 12 && (
          <button
            className={styles.button}
            onClick={() => {
              filters.showMoreCardsBtn()
            }}
          >
            <span className={styles.textBtn}>Смотреть еще</span>
            <div className={styles.arrow}></div>
          </button>
        )}
        {filteredCards.length === 0 && <div className={styles.caution}>
        Ничего не найдено <br/> Смените параметры фильтрации 
        </div>}
        </div>
        
      
      
      
        )}

      
    </section>
  )
}

export default Gallery
